import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./app";
import "./index.css";
import { watchTouch } from "./ui/touch";

const container = document.getElementById("root");
if (container === null) throw new Error("index.html is missing #root");

// A touch screen gets finger-sized targets (OQ-D32).
watchTouch();

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
